module.exports = __webpack_public_path__ + "img/Ida.368ee673.jpeg";